import type { PressItem } from '~/content/news';
import { SmartImage } from '~/components/ui';
import { ScrollStrip } from './ScrollStrip';

export function PressStrip({ items, className }: { items: PressItem[]; className?: string }) {
  return (
    <ScrollStrip
      plain
      autoScroll
      className={className}
      items={items}
      getKey={(item) => item.href}
      itemClassName="pr-6"
      renderItem={(item) => <PressCard item={item} />}
    />
  );
}

function PressCard({ item }: { item: PressItem }) {
  return (
    <a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      draggable={false}
      className="group flex h-[440px] w-[293px] flex-col overflow-hidden bg-grey-25">
      {item.image && (
        <SmartImage image={item.image} className="pointer-events-none h-[201px] w-full shrink-0" />
      )}
      <div className="flex flex-1 flex-col px-5 pt-6 pb-6">
        <time
          dateTime={item.publishedAt}
          className="text-[15px] leading-[1.32] tracking-[0.27px] text-grey-700">
          {item.date}
        </time>
        <h3 className="mt-4 text-[17px] leading-[1.25] font-semibold tracking-[-0.2px] text-ink">
          <span className="link-underline-lr bg-origin-content">{item.title}</span>
        </h3>
        <p className="mt-auto pt-6 text-[15px] leading-[1.32] font-semibold tracking-[0.27px] text-red-500">
          {item.outlet}
        </p>
      </div>
    </a>
  );
}
